import { ChangeDetectionStrategy, Component, input, output, Signal } from '@angular/core';
import { NgClass } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

export interface DatabaseTabs<T> {
  value: T;
  labelKey: string;
  iconName: string;
  count: Signal<number>;
}

@Component({
  selector: 'app-database-tabs',
  imports: [NgClass, TranslatePipe],
  templateUrl: './database-tabs.component.html',
  styleUrl: './database-tabs.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DatabaseTabsComponent<T> {
  readonly tabs = input.required<DatabaseTabs<T>[]>();
  readonly activeTab = input.required<string>();
  readonly activeTabChange = output<T>();

  selectTab(tabValue: T): void {
    this.activeTabChange.emit(tabValue);
  }
}
